import React from 'react'

import { Cell, Line, Terminal } from '../interface'

import { Row } from './Row'

export interface GridProps {
    grid: Cell[][]
    terminalCellDict: Array<Array<Terminal | undefined>>
    lineSourceCellDict: Array<Array<Array<Line>>>
    lineDestinationCellDict: Array<Array<Array<Line>>>
}

export const Grid = React.memo((props: GridProps): JSX.Element => {
    const { grid, terminalCellDict, lineSourceCellDict, lineDestinationCellDict } = props

    return <> {
        grid.map((cells: Cell[], index: number) => <Row key={index}
            cells={cells}
            terminalCellDict={terminalCellDict}
            lineSourceCellDict={lineSourceCellDict}
            lineDestinationCellDict={lineDestinationCellDict} />)
    } </>
})
